import {takeEvery} from 'redux-saga/effects';
import types from "./types";
import {takeQuery} from "../../agent";

const File = {
	download: ({api, fileId}) => api.pdf('/files/download', null, {fileId}),
	downloadAsBA: ({api, fileId, thumbnail}) =>
		api._safeQuery(
			api._axios.get,
			'/files/download',
			null,
			{fileId, thumbnail},
			false,
			false,
			{
				responseType: 'arraybuffer'
			}
		)
}

export default [
	takeQuery(types.DOWNLOAD_FILE, {
		api: File.download,
	}),
	takeQuery(types.DOWNLOAD_FILE_AS_BA, {
		api: File.downloadAsBA,
		effect: takeEvery
	})
];
